"use client";
import { ReactNode, useEffect } from "react";
import { useUploadStore } from "@stores/upload";

type ConfirmationProviderProps = {
	children: ReactNode;
};

const ConfirmationProvider = ({ children }: ConfirmationProviderProps) => {
	const { getAllActiveUploads } = useUploadStore();
	const isUploading = getAllActiveUploads().length > 0;

	useEffect(() => {
		const handleBeforeUnload = (event: BeforeUnloadEvent) => event.preventDefault();

		if (isUploading) {
			window.addEventListener("beforeunload", handleBeforeUnload);
		}

		return () => window.removeEventListener("beforeunload", handleBeforeUnload);
	}, [isUploading]);

	return children;
};

export default ConfirmationProvider;
